module.exports = __webpack_public_path__ + "static/media/singapore-pin.65d03b67.svg";